import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class EventIndexRoute extends Route 
{
	@service router;
	
	redirect()
	{
		this.router.transitionTo('event.class-groups');
	}
}
